import styled from 'styled-components';
import { baseVariables } from '@marriott/mi-ui-library';

export const DisclaimerWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
`;

export const DisclaimerContent = styled.div<{ $context: 'welcome' | 'chat' }>`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%;
  line-height: 1.5;

  /* Override ABody / global link styles so disclaimer links match body copy color */
  p,
  span,
  a,
  a:visited,
  a:hover,
  a:focus {
    font-family: var(--typography-font-family, 'Swiss721 BT', sans-serif);
    font-size: 12px;
    font-weight: var(--typography-body-font-weight, 500);
    line-height: 1.5;
    color: var(--color-set-brand-alt-color, var(--t-brand-alt-color, #707070));
    margin: 0;
    padding: 0;
    display: inline;
  }

  /* Mobile: Left-align text for better readability */
  @media ${baseVariables.mediaQuery.sm} {
    text-align: center;
    justify-content: center;
  }
  @media (max-width: 768px) {
    margin-right: var(--general-spacer-04, 24px);
  }

  ${({ $context }) =>
    $context === 'welcome'
      ? `
    .legal-chat-disclaimer {
      display: none !important;
    }
    .legal-welcome-disclaimer {
      display: block;
    }
  `
      : `
    .legal-welcome-disclaimer {
      display: none !important;
    }
    .legal-chat-disclaimer {
      display: block;
    }
  `}
`;
